import Avatar from "./basic-15-avatar.png";
import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic15 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #15";
    this.name = "Basic #15";
    this.id = "15";
    this.url = "/ai/carousels/basic-15";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@jon-snow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#CBF9D4",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#000000",
        },
        {
          label: "Secondary Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#FFFFFF",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Barlow Condensed",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Barlow",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "BUSINESS MINDSET & PERSONAL GROWTH",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "THE ESSENCE OF LEADERSHIP",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Leadership isn't just a title; it's a responsibility. Leaders inspire, motivate, and set the tone for their teams. As a leader, your actions and decisions impact your team's performance and overall success`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "CUMMUNICA-TION MASTERY",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Effective communication is the foundation of strong leadership. Clear and open communication fosters understanding, trust, and collaboration within your team. Keep the lines of communication open and transparent.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "BUILDING A COHESIVE TEAM",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Empowerment empowers growth! Delegate tasks to team members, allowing them to showcase their skills and take ownership. Empowered individuals contribute to a stronger and more agile team.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: `don’t forget to save this post`,
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Barlow Condensed";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[7]?.value || "Barlow";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="absolute inset-x-0 top-[113px] px-[32px]"
          style={{
            fontFamily: this.getPrimaryFont(commonSettings),
          }}
        >
          <div
            className="uppercase text-[60px] leading-[60px] font-semibold"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
        </div>
        <div className="absolute inset-x-0 top-[448px] left-[32px]">
          <svg
            width="61"
            height="20"
            viewBox="0 0 61 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 10.2715C19.9397 12.8956 18.89 15.3646 16.7644 17.3557C15.7925 18.2662 14.6695 18.9393 13.4193 19.3929C12.0507 19.8904 10.5899 20.0826 9.1393 19.9559C7.68869 19.8292 6.2833 19.3867 5.02156 18.6595C4.92447 18.6036 4.846 18.6213 4.75437 18.6548C3.57485 19.0849 2.39532 19.5167 1.21407 19.9408C0.863685 20.0665 0.540869 19.9904 0.276656 19.7286C0.00871841 19.463 -0.0672676 19.1375 0.060369 18.7815C0.489467 17.5835 0.923034 16.3871 1.36107 15.1924C1.37514 15.1587 1.38069 15.1221 1.37723 15.0857C1.37376 15.0494 1.36139 15.0144 1.34121 14.984C0.912669 14.2471 0.582648 13.457 0.359595 12.6342C0.0714628 11.591 -0.0428892 10.5074 0.0211344 9.42699C0.151585 7.27478 0.89398 5.36025 2.24832 3.68341C3.33422 2.34179 4.68831 1.35223 6.29222 0.712482C7.66774 0.160784 9.14935 -0.075481 10.6281 0.021055C14.4555 0.256582 17.8163 2.67595 19.2632 6.24166C19.7514 7.44389 19.9898 8.69681 20 10.2715Z"
              fill={this.getPrimaryColor(commonSettings)}
            />
            <path
              d="M55.2253 0.45459C52.1855 0.45459 50.5003 2.62897 50.5003 2.62897C50.5003 2.62897 48.815 0.45459 45.7753 0.45459C42.5854 0.45459 40.0002 3.01598 40.0002 6.17663C40.0002 10.516 45.1579 14.7212 46.5953 16.0498C48.2512 17.5791 50.5003 19.5454 50.5003 19.5454C50.5003 19.5454 52.7494 17.5791 54.4052 16.0498C55.8427 14.7212 61.0003 10.516 61.0003 6.17663C61.0003 3.01598 58.4152 0.45459 55.2253 0.45459Z"
              fill={this.getPrimaryColor(commonSettings)}
            />
          </svg>
        </div>
        <div className="absolute w-[90px] h-[113px] top-[355px] left-[278px]">
          <svg
            width="90"
            height="113"
            viewBox="0 0 90 113"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M90 111.867C90 112.336 89.4658 112.606 89.0878 112.328L45.3396 80.0873C45.1377 79.9384 44.8623 79.9384 44.6604 80.0873L0.91216 112.328C0.534156 112.606 0 112.336 0 111.867V0.572509C0 0.25632 0.256322 0 0.572512 0H89.4275C89.7437 0 90 0.256322 90 0.572512V111.867Z"
              fill={this.getPrimaryColor(commonSettings)}
            />
          </svg>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="absolute inset-x-0 top-[113px] px-[32px] flex flex-col gap-[20px]"
          style={{
            fontFamily: this.getPrimaryFont(commonSettings),
          }}
        >
          <div
            className="uppercase text-[60px] leading-[60px] font-semibold"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[14px] leading-[22px] font-normal"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getSecondaryFont(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="absolute inset-x-0 top-[113px] px-[32px]"
          style={{
            fontFamily: this.getPrimaryFont(commonSettings),
          }}
        >
          <div
            className="uppercase text-[60px] leading-[60px] font-semibold"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getSecondaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0 ">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            >
              <svg
                width="400"
                height="500"
                viewBox="0 0 400 500"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <g opacity="0.1">
                  <rect
                    width="400"
                    height="500"
                    fill={"url(#pattern0" + index + ")"}
                  />
                </g>
                <defs>
                  <pattern
                    id={"pattern0" + index}
                    patternContentUnits="objectBoundingBox"
                    width="0.055"
                    height="0.044"
                  >
                    <use
                      xlinkHref="#image0_1369_117"
                      transform="scale(0.0025 0.002)"
                    />
                  </pattern>
                  <image
                    id="image0_1369_117"
                    width="22"
                    height="22"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAFVJREFUOBHtkM0KACAMgvf+L11dvAg66Ac6GMTYzG9kVdVY151Od14JP4JiI0O4x7utChjqFkSZnkKvwhnGvfqhnSuImlsYxM7c6eCkJoEkkAT+SWACsrAQ8PzadOkAAAAASUVORK5CYII="
                  />
                </defs>
              </svg>
            </div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}

        <div
          className="absolute inset-x-0 w-full top-[40px] px-[32px] flex flex-col gap-[15px]"
          style={{
            color: this.getPrimaryColor(commonSettings),
          }}
        >
          <div className="w-full flex justify-between items-center">
            <div className="flex gap-[8px] items-center">
              <img
                className="object-cover w-[24px] h-[24px] rounded-full"
                src={
                  commonSettings.elements[1].value.image
                    ? commonSettings.elements[1].value.image
                    : LogoPlaceholder
                }
                style={{
                  backgroundColor: this.getPrimaryColor(commonSettings),
                }}
                alt=""
              />

              <p
                className="font-semibold text-[16px] leading-[24px] whitespace-nowrap"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                }}
              >
                {commonSettings.elements[0].value}
              </p>
            </div>
            <p className="text-[12px] leading-[18px] font-normal">
              {commonSettings.elements[2].value}
            </p>
          </div>
          <div
            className="w-full h-[2px] rounded-full"
            style={{
              backgroundColor: this.getPrimaryColor(commonSettings),
            }}
          />
        </div>
        {index !== carouselLength - 1 && (
          <div className="absolute inset-x-0 w-full px-[32px] h-[56px] top-[412px] rounded-full flex gap-[16px] items-center justify-center">
            <div
              className="h-full w-full rounded-full flex gap-[16px] items-center justify-center"
              style={{
                backgroundColor: this.getSecondaryColor(commonSettings),
                color: this.getPrimaryColor(commonSettings),
              }}
            >
              <p className="text-[24px] leading-[32px] font-semibold ">SWIPE</p>
              <svg
                width="199"
                height="28"
                viewBox="0 0 199 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M183.851 1.22217L197.758 13.9999L183.851 26.7777"
                  stroke={this.getPrimaryColor(commonSettings)}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M198 14H1"
                  stroke={this.getPrimaryColor(commonSettings)}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Basic15;
